import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SolicitudesPendientesAprobacionDTO } from 'src/app/infraestructure/interfaces/referente/SolicitudPendienteAprobacionDTO';

@Component({
  selector: 'app-table-request-pending',
  templateUrl: './table-request-pending.component.html',
  styleUrls: ['./table-request-pending.component.scss']
})
export class TableRequestPendingComponent implements OnInit {

  @Output() itemSelected = new EventEmitter<number>();
  @Output() checked = new EventEmitter<boolean>();
  @Output() solicitudSeleccionada = new EventEmitter<SolicitudesPendientesAprobacionDTO>();

  @Input() set data(data: SolicitudesPendientesAprobacionDTO[]){
    this.dataTable = data;
  }

  valueSelected: number = 0;

  dataTable: SolicitudesPendientesAprobacionDTO[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  onSelected(event: any) {
    const item: any = (event.target as HTMLInputElement).value;
    const check: any = (event.target as HTMLInputElement).checked;

    this.checked.emit(check);
    
    if (item < 1 || !check) return;

    this.valueSelected = item;
    this.itemSelected.emit(item);
  }

  dataSelected(data: SolicitudesPendientesAprobacionDTO) {
    this.solicitudSeleccionada.emit(data);
  }
}
